import styled from "styled-components"
import { Link } from "react-router-dom"
import HeaderLinks from "../components/HeaderLinks"
import DonateButton from "../components/DonateButton"
import FloodVictims2 from "../assets/images/flood-victims-2.jpg"
import EIPLogo from "../assets/logos/EIP_logo.png"
import DirectFreshLogo from "../assets/logos/direct-fresh-logo.png"
import ThriveLogo from "../assets/logos/thrive-logo.png"
import { phoneWidth } from "../Globalstyle"

const HeroImageContainer = styled.div`
  height: 30rem;
  position: relative;
`

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Info = styled.div`
  padding: var(--side-padding);
`

const TextRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  align-items: flex-start;
  margin-bottom: 5rem;
  gap: 2rem;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }
`

const Tagline = styled.div`
  font-size: 3.25rem;
  font-weight: bold;
  width: 100%;
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  gap: 1.5rem;
  width: 100%;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

const LogoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 6rem;

  @media (max-width: ${phoneWidth}) {
    height: 3.5rem;
  }
`

const LogoContainer = styled.a`
  height: 100%;
`

const LogoContainerInternal = styled(Link)`
  height: 100%;
`

const Logo = styled.img`
  height: 100%;
`

const LandingBanner = () => {
  return (
    <>
      <HeroImageContainer>
        <HeaderLinks/>
        <HeroImage src={FloodVictims2} alt="Flood Victims"/>
      </HeroImageContainer>
      <Info>
        <TextRow>
          <Tagline>
            Together we will prevail
          </Tagline>
          <Details>
            <div>
              Earth Identity Project is working in conjunction with Direct Fresh
              &amp; Thrive to provide short, medium and long term assistance 
              for those worst affected by the flooding in Sylhet. 
              The focus will be not just on short term relief but on long term 
              rehabilitation.
            </div>
            <ButtonContainer>
              <DonateButton/>
            </ButtonContainer>
          </Details>
        </TextRow>
        <LogoRow>
          <LogoContainerInternal to="/about-us">
            <Logo src={EIPLogo} alt="Earth Identity Project Logo"/>
          </LogoContainerInternal>
          <LogoContainer href="https://directfreshbd.com/" target="_blank">
            <Logo src={DirectFreshLogo} alt="Direct Fresh Logo"/>
          </LogoContainer>
          <LogoContainer href="https://www.thrive-global.org/" target="_blank">
            <Logo src={ThriveLogo} alt="Thrive Logo"/>
          </LogoContainer>
        </LogoRow>
      </Info>
    </>
  )
}

export default LandingBanner